import { Option } from '@spike/model';
import clsx from 'clsx';
import { useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import MultipleListContent from './MultipleListContent';
import styles from './MultipleSelector.module.scss';
import SelectorHeader from './SelectorHeader';
import SelectorListContainer from './SelectorListContainer';

interface MultipleSelectorProps<T> {
    placeholder?: string;
    options: Array<Option<T>>;
    selectedIds: Array<T>;
    width?: number;
    allOptionLabel?: string;
    enableSearch?: boolean;
    selectedLabel?: string;
    className?: string;
    onChange?: (selectedIds: Array<T>) => void;
}

export const MultipleSelector = <T,>(props: MultipleSelectorProps<T>) => {
    const [expanded, setExpanded] = useState(false);

    const containerStyle = { width: props.width };

    const clickHeaderHandler = () => {
        setExpanded(prev => !prev);
    };

    const list = (
        <ClickAwayListener onClickAway={() => setExpanded(false)}>
            <div>
                <SelectorListContainer>
                    <MultipleListContent
                        options={props.options}
                        selectedIds={props.selectedIds}
                        allOptionLabel={props.allOptionLabel}
                        enableSearch={props.enableSearch}
                        onChange={props.onChange}
                    />
                </SelectorListContainer>
            </div>
        </ClickAwayListener>
    );

    return (
        <div
            className={clsx(styles.container, props.className)}
            style={containerStyle}
        >
            <SelectorHeader
                placeholder={props.placeholder}
                expanded={expanded}
                selectedLabel={props.selectedLabel}
                onClick={clickHeaderHandler}
            />
            {expanded && list}
        </div>
    );
};

export default MultipleSelector;
